import http from "./http-service"

export default class ZipCodeService {

  static getAddress(zipCode) {
    return http.get(`zipcode/${zipCode}`)
  }

  static search(keyWord) {
    return http.post("zipcode/search", { keyWord })
  }
}